
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h34v20H0z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"data-name":"SVGID","fill":"none","d":"M0 0h34v20H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Rectangle 235","fill":"#e0001a","d":"M0 0h7.998v20H0z"}}),_c('path',{attrs:{"data-name":"Rectangle 236","fill":"#e0001a","d":"M26.002 0H34v20h-7.998z"}}),_c('path',{attrs:{"data-name":"Rectangle 237","fill":"#fff","d":"M7.998 0h18.003v20H7.998z"}}),_c('g',{attrs:{"data-name":"Group 18"}},[_c('g',{attrs:{"data-name":"Group 17","clip-path":"url(#b)"}},[_c('path',{attrs:{"data-name":"Path 591","d":"M17 2.593l-1.179 2.311c-.134.251-.373.228-.614.087l-.853-.465.636 3.55c.134.648-.3.648-.508.368l-1.49-1.752-.242.89a.288.288 0 0 1-.335.21l-1.884-.416.5 1.89c.106.421.188.6-.107.706l-.671.331 3.243 2.768a.46.46 0 0 1 .147.463l-.284.979 3.234-.391c.1 0 .264.087.263.207l-.148 3.586h.543l-.085-3.578c0-.12.148-.217.248-.215l3.234.391-.284-.979a.459.459 0 0 1 .147-.463l3.243-2.768-.672-.331c-.3-.111-.213-.285-.107-.706l.495-1.89-1.884.416a.288.288 0 0 1-.334-.21l-.242-.89-1.49 1.752c-.212.281-.641.281-.507-.368l.636-3.55-.854.465c-.24.14-.479.164-.613-.087z","fill":"#e0001a"}})])])])])
          )
        }
      }
    